import { AppLocaleMessageObject, LocaleOptions } from "@/plugins/i18n/types";

const BaseMessages: AppLocaleMessageObject = {
  home: {
    welcome: "Добредојдовте",
    liveChannelsHeading: "Канали во живо",
    watchNow: "Гледајте сега"
  },
  sidebar: {
    home: "Дома",
    channels: "Во живо / Канали",
    buffet: "Бифе EPG",
    settings: "Поставки",
    vod: "VoD библиотека"
  },
  buffet: {
    datesFilter: {
      today: "Денеска",
      yesterday: "Вчера",
      tomorrow: "Утре"
    },
    epgCard: {
      play: "Пушти",
      epg: "EPG",
      info: "Инфо"
    }
  },
  channelsPage: {
    nowOnTV: "Сега на ТВ",
    channels: "Канали",
    infoPage: {
      play: "Пушти"
    },
    epgCard: {
      play: "Пушти",
      epg: "EPG",
      info: "Инфо"
    },
    channelCard: {
      play: "Пушти",
      epg: "EPG",
      add: "Додадете"
    }
  },
  categoriesEnum: {
    allChannels: "Сите канали",
    favorites: "Омилени"
  },
  buffetCategoriesEnum: {
    home: "Дома"
  },
  vodPage: {
    types: {
      movies: "Филмови",
      tvShows: "ТВ емисии"
    },
    vodCard: {
      play: "Пушти",
      info: "Инфо",
      add: "Додадете"
    }
  },
  settings: {
    title: "Прегледајте го вашиот",
    subTitle: "Поставки",
    profileSectionTitle: "Профил:",
    personalSectionTitle: "Лично:",
    otherSectionTitle: "Друго:",
    cardsPersonal: {
      logout: "Одјавување",
      restart: "Рестарт",
      language: {
        heading: "Изберете",
        subHeading: "Јазик"
      },
      pin: {
        heading: "Промена",
        subHeading: "Пин за заклучување"
      }
    },
    cardsOther: {
      sortAndLock: {
        heading: "Сортирајте и заклучете",
        subHeading: "ги каналите"
      },
      support: {
        heading: "Поддршка, За апликацијата",
        subHeading: "Општи информации",
        headingRightSideMenu: "Поддршка"
      }
    },
    cardsProfile: {
      btnEdit: "Уредување",
      btnDelete: "Избриши",
      user: {
        profile: "Профил",
        child: "Дете"
      },
      addNew: {
        addChild: "Додадете дете",
        createNew: "Создадете ново"
      }
    },
    rightSideMenu: {
      logoutBtn: "Одјавување",
      restartBtn: "Рестарт",
      oldPinInput: "Внесете го стариот PIN*",
      newPinInput: "Внесете нов PIN*",
      confirmNewPinInput: "Ве молиме повторно внесете нов PIN",
      confirmPinBtn: "Потврди",
      contactUs: "Контактирајте не на:"
    },
    confirmModal: {
      userDelete: "Дали сте сигурни дека сакате да го избришете корисникот?",
      backToSettings:
        "Дали сте сигурни дека сакате да се вратите на „Поставки“?",
      yes: "Да",
      no: "бр"
    },
    pinModal: {
      confirmPinText: "Ве молиме внесете PIN-код",
      pinInput: "Вашиот PIN овде",
      confirmBtn: "Потврди"
    },
    editUserForm: {
      username: "* Корисничко име / Име на профил:",
      name: "* Име",
      lastName: "* Презиме",
      email: "* Е-пошта",
      phone: "* Телефон",
      oldPass: "* Стара лозинка",
      password: "* Лозинка",
      confirmPass: "* Потврди ја лозинката",
      oldPin: "* Внесете го стариот ПИН",
      pin: "* PIN кодот",
      confirmPin: "* Потврдете PIN",
      saveBtn: "Зачувај",
      title: "Уреди корисник",
      subTitle: "Профил"
    },
    sortAndLock: {
      title: "Подреди и заклучи",
      subTitle: "Канали",
      cardLock: "Заклучување",
      cardUnlock: "Отклучи",
      cardSort: "Подреди",
      cardAdd: "Додадете",
      cardRemove: "Отстрани"
    }
  },
  overlay: {
    backBtn: "назад",
    contentNext: {
      later: "Подоцна",
      upNext: "Следно",
      nextEpisodeBtn: "Следна епизода"
    }
  }
};

const MK: LocaleOptions = {
  BaseMessages
};

export default MK;
